import { render, staticRenderFns } from "./sidemenu_post.vue?vue&type=template&id=4fd658f6&"
import script from "./sidemenu_post.vue?vue&type=script&lang=js&"
export * from "./sidemenu_post.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports